/* eslint-disable */
import * as types from './graphql';
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

/**
 * Map of all GraphQL operations in the project.
 *
 * This map has several performance disadvantages:
 * 1. It is not tree-shakeable, so it will include all operations in the project.
 * 2. It is not minifiable, so the string of a GraphQL query will be multiple times inside the bundle.
 * 3. It does not support dead code elimination, so it will add unused operations.
 *
 * Therefore it is highly recommended to use the babel or swc plugin for production.
 * Learn more about it here: https://the-guild.dev/graphql/codegen/plugins/presets/preset-client#reducing-bundle-size
 */
type Documents = {
    "query ViewScheduledBusesQuery { viewScheduledBuses { __typename scheduleEntries { __typename route direction stopId stopName serviceDay tripId scheduledArrival destinationLabel } lastUpdatedAt } }": typeof types.ViewScheduledBusesQueryDocument,
    "query RefreshScheduledBusesQuery { refreshScheduledBuses { __typename scheduleEntries { __typename route direction stopId stopName serviceDay tripId scheduledArrival destinationLabel } lastUpdatedAt } }": typeof types.RefreshScheduledBusesQueryDocument,
    "mutation PublishScheduleDataMutation($input: PublishScheduleDataInput!) { publishScheduleData(input: $input) { __typename success error { __typename type message } } }": typeof types.PublishScheduleDataMutationDocument,
};
const documents: Documents = {
    "query ViewScheduledBusesQuery { viewScheduledBuses { __typename scheduleEntries { __typename route direction stopId stopName serviceDay tripId scheduledArrival destinationLabel } lastUpdatedAt } }": types.ViewScheduledBusesQueryDocument,
    "query RefreshScheduledBusesQuery { refreshScheduledBuses { __typename scheduleEntries { __typename route direction stopId stopName serviceDay tripId scheduledArrival destinationLabel } lastUpdatedAt } }": types.RefreshScheduledBusesQueryDocument,
    "mutation PublishScheduleDataMutation($input: PublishScheduleDataInput!) { publishScheduleData(input: $input) { __typename success error { __typename type message } } }": types.PublishScheduleDataMutationDocument,
};

/**
 * The gql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 *
 *
 * @example
 * ```ts
 * const query = gql(`query GetUser($id: ID!) { user(id: $id) { name } }`);
 * ```
 *
 * The query argument is unknown!
 * Please regenerate the types.
 */
export function gql(source: string): unknown;

/**
 * The gql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function gql(source: "query ViewScheduledBusesQuery { viewScheduledBuses { __typename scheduleEntries { __typename route direction stopId stopName serviceDay tripId scheduledArrival destinationLabel } lastUpdatedAt } }"): (typeof documents)["query ViewScheduledBusesQuery { viewScheduledBuses { __typename scheduleEntries { __typename route direction stopId stopName serviceDay tripId scheduledArrival destinationLabel } lastUpdatedAt } }"];
/**
 * The gql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function gql(source: "query RefreshScheduledBusesQuery { refreshScheduledBuses { __typename scheduleEntries { __typename route direction stopId stopName serviceDay tripId scheduledArrival destinationLabel } lastUpdatedAt } }"): (typeof documents)["query RefreshScheduledBusesQuery { refreshScheduledBuses { __typename scheduleEntries { __typename route direction stopId stopName serviceDay tripId scheduledArrival destinationLabel } lastUpdatedAt } }"];
/**
 * The gql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function gql(source: "mutation PublishScheduleDataMutation($input: PublishScheduleDataInput!) { publishScheduleData(input: $input) { __typename success error { __typename type message } } }"): (typeof documents)["mutation PublishScheduleDataMutation($input: PublishScheduleDataInput!) { publishScheduleData(input: $input) { __typename success error { __typename type message } } }"];

export function gql(source: string) {
  return (documents as any)[source] ?? {};
}

export type DocumentType<TDocumentNode extends DocumentNode<any, any>> = TDocumentNode extends DocumentNode<  infer TType,  any>  ? TType  : never;